export class MusicTranscriptionWorkerController {
  private worker: Worker | null;

  constructor(callback: (event: MessageEvent<any>) => void, onError?: (event: ErrorEvent) => void) {
    this.worker = new Worker('./MusicTranscriptionWorker.ts', {type: 'module'});
    this.worker.addEventListener("message", (event) => {
      callback(event);
    })
    if (onError) {
      // Catches worker-thread errors that happen synchronously (e.g. during construction);
      // an unhandled rejection inside an async init (network failure loading the model, etc.)
      // won't necessarily surface here — instanciateWorker()'s init timeout is the real safety net.
      this.worker.addEventListener("error", onError);
    }
  }

  public post(type: string, data: any) {
    this.worker?.postMessage({type, data});
  }

  public terminate(): void {
    if (this.worker) {
      this.worker.terminate();
      this.worker = null;
    }
  }
}